import BuyTrainTicketsIndex from '@/views/scene/BuyTrainTickets/index.vue';
const MainRoutes = Array.from({ length: 22 }, (_, i) => ({
  path: `BuyTrainTickets/index${i + 1}`,
  name: `BuyTrainTicketsIndex${i + 1}`,
  component: () => import(`@/views/scene/BuyTrainTickets/index${i + 1}.vue`)
}))

export default {
  path: '/scene',
  component: {
    render (c) {
      return c('router-view')
    }
  },
  children: [
     // 买火车票首页
    {
      path: 'BuyTrainTicketsIndex',
      name: 'BuyTrainTicketsIndex',
      component: BuyTrainTicketsIndex
    },
    ...MainRoutes,
  ]
}
